<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="dialogStatus"
    :width="'414px'"
    center
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div class="tip-wrap">
      <h2>设置新密码</h2>
      <p>您可在下次登录时使用密码登录</p>
      <p>密码至少6位长度， </p>
      <p>且由小写字母，大写字母，数字，和特殊符号组成</p>
    </div>
    <el-form
      ref="modifyPassDataForm"
      :model="modifyPassVal"
      :rules="modifyPassRules"
      label-position="top"
    >
      <!-- <el-form-item prop="oldPassword" label="原密码" :label-width="formLabelWidth">
        <el-input v-model.trim="modifyPassVal.oldPassword" type="password" autocomplete="off" />
      </el-form-item> -->
      <el-form-item prop="newPassword" label="输入密码">
        <!-- :label-width="formLabelWidth" -->
        <el-input v-model.trim="modifyPassVal.newPassword" type="password" autocomplete="off" clearable />
      </el-form-item>
      <el-form-item prop="confirmPassword" label="确认密码">
        <el-input
          v-model.trim="modifyPassVal.confirmPassword"
          type="password"
          autocomplete="off"
          clearable
          @keyup.enter.native="saveModifyPass"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" class="confirm-btn" @click="saveModifyPass">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { validPassword } from '@/helpers/validate'
import { JSEncrypt } from 'jsencrypt'

export default {
  name: 'Modifypass',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateNewPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (!validPassword(value)) {
        callback(new Error('密码至少6位长度，且由小写字母、大写字母、数字和特殊符号组成'))
      } else if (this.errorKeys.indexOf('newPassword') >= 0) {
        callback(new Error(this.errorInfo['newPassword']))
        this.resetError('newPassword')
      } else {
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value || value !== this.modifyPassVal.newPassword) {
        callback(new Error('请确认密码'))
      } else if (this.errorKeys.indexOf('confirmPassword') >= 0) {
        callback(new Error(this.errorInfo['confirmPassword']))
        this.resetError('confirmPassword')
      } else {
        callback()
      }
    }

    return {
      formLabelWidth: '100px',
      isLoading: false,
      dialogStatus: '',
      modifyPassVal: {
        // oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      modifyPassRules: {
        newPassword: [{ required: true, trigger: ['change'], validator: validateNewPassword }],
        confirmPassword: [{ required: true, trigger: ['change'], validator: validateConfirmPassword }]
      },
      errorKeys: [],
      errorInfo: {}
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.isShow
      },
      set(val) {
        this.$emit('update:isShow', val)
      }
    }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)',
          target: '.model-content'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    },
    isVisible(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs['modifyPassDataForm'].clearValidate()
        })
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.modifyPassVal = {
        // oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    resetError(val) {
      if (val) {
        const index = this.errorKeys.indexOf(val)
        this.errorKeys.splice(index, 1)
        delete this.errorInfo.val
      } else {
        this.errorKeys = []
        this.errorInfo = {}
      }
    },
    encryptStr(val) {
      const publicKey = process.env.VUE_APP_PUBLIC_KEY
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(publicKey)
      const result = encrypt.encrypt(val)

      // console.log(result)
      return result
    },
    saveModifyPass() {
      this.$refs.modifyPassDataForm.validate(valid => {
        if (!valid) return
        this.isLoading = true

        const data = {
          newPassword: this.encryptStr(this.modifyPassVal.newPassword)
        }

        this.$api.login.setNewPass(data)
          .then(res => {
            this.gtag('event', 'usr_set_pwd_success')

            this.isLoading = false
            this.isVisible = false
            this.$message.success('设置密码成功')
            // 设置新密码成功， 刷新数据
            this.$store.dispatch('user/SET_ACCOUNT_INFO', {
              modifyPassFlag: 'N',
              firstLoginFlag: 'N'
            })

            this.$nextTick(() => {
              this.$router.push({ path: '/stores' })
            })
          })
          .catch(err => {
            if (err.errorInfos && err.errorInfos.length > 0) {
              this.resetError()
              err.errorInfos.forEach(item => {
                this.errorKeys.push(item.key)
                this.errorInfo[item.key] = item.errMsg
              })

              this.$refs['modifyPassDataForm'].validate(valid => {
                console.log(valid)
              })
            }
            this.isLoading = false
            // this.$message.error('保存失败')
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-wrap {
  margin-bottom: 20px;

  h2 {
    font-size: 24px;
    line-height: 2;
  }

  p {
    line-height: 1.6;
  }
}

/deep/ .el-form-item__label {
  padding: 0 !important;
}

.confirm-btn {
  @include btn_page_primary('color');
}
</style>
